export default __webpack_public_path__ + "static/media/visa-card.01454aad.png";